import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { reactive, watch, toRaw, ref, onMounted, computed } from 'vue'
import { cloneDeep, isEqual } from 'lodash-es'
import { Form } from 'ant-design-vue'
import ClueAndCustomerSelect from '@/components/ClueAndCustomerSelect/index.vue'
import BusinessName from '@/components/BusinessName/index.vue'
import CosSingleDateTimePicker from '@/components/CosSingleDateTimePicker/index.vue'
import { remindTypeEnum } from '../dataConfig'
import { listByParamCodes } from '@/api/common'
import { businessSelectListByRefId } from '@/api/overseasSales/chanceManage'
import { selectForNumberValidate } from '@/utils/validate'
import { paramCodesDataFilter } from '@/utils/index'
import type { ParamCodeItem } from '@/typings/common'
import type { FbuVisitorProgramEditParams } from '@/typings/api/followUpManage'
import { useI18n } from 'vue-i18n'

const __default__ = { name: 'VisitorProgramForm' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  value: Object,
  title: String,
  saleChanceRefId: [String, Number], // 客户id，当传入有值的时候需要设置客户名称不可选
  isEdit: {
    type: Boolean,
    default: true
  },
  type: {
    type: String,
    default: 'add'
  }
},
  emits: ['update:value'],
  setup(__props, { expose: __expose, emit: __emit }) {

const { t } = useI18n()
const useForm = Form.useForm

const props = __props

const querySaleChanceRefId = computed(() => props.saleChanceRefId)
const paramCodeData: {
  [key: string]: ParamCodeItem[]
} = reactive({
  ofbu_follow_purpose: [], // 拜访目的
  ofbu_follow_mode: [] // 拜访方式（跟进方式）
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: ['ofbu_follow_purpose', 'ofbu_follow_mode']
  }).then((res) => {
    if (props.type !== 'view') {
      // 递归过滤业务参数状态
      res.data = paramCodesDataFilter(res.data, 0)
    }
    Object.assign(paramCodeData, res.data)
  })
}
onMounted(() => getByParamCodes())

const dataForm = reactive<FbuVisitorProgramEditParams>({
  visitRefId: undefined,
  title: undefined,
  startTime: undefined,
  purpose: undefined,
  mode: undefined,
  chanceId: undefined
})
const isOtherTime = ref(false) // 是否其它时间
// // 动态判断“关联商机”是否必填
// const isAberrant = computed(() => {
//   if (dataForm.purpose) {
//     const find = paramCodeData.ofbu_follow_purpose.find((e) => e.id === dataForm.purpose)
//     return find?.name !== '处理异常' && chanceEnumComputed.value.length > 0
//   } else {
//     return false
//   }
// })
const formRules = reactive({
  visitRefId: [{ required: true, validator: selectForNumberValidate, message: t('common.pleaseSelect') }],
  title: [{ required: true, message: t('common.pleaseInput') }],
  startTime: [{ required: true, message: t('common.pleaseSelect') }],
  purpose: [{ required: true, validator: selectForNumberValidate, message: t('common.pleaseSelect') }],
  mode: [{ required: true, validator: selectForNumberValidate, message: t('common.pleaseSelect') }],
  // chanceId: [{ required: isAberrant, message: '当目的不是[处理异常]且存在商机时,[关联商机]必填' }],
  remindTime: [{ required: isOtherTime, message: t('common.pleaseSelect') }]
})

// 获取关联商机
const chanceEnum = ref<any[]>([])
const getChanceEnum = (id: string) => {
  businessSelectListByRefId(id).then((res) => {
    chanceEnum.value = res.data
  })
}
const handleCustomerNameChange = (value?: any) => {
  dataForm.chanceName = undefined
  dataForm.chanceId = undefined
  if (!value) {
    chanceEnum.value = []
  }
}
const handleChanceChange = (value?: any) => {
  dataForm.chanceName = value ? chanceEnum.value.find((e) => e.chanceId === value)?.label : undefined
}
const chanceEnumComputed = computed(() => {
  if (props.type === 'add') {
    // 可选该客户下状态为 “初步洽谈、需求确认、制定方案”的商机
    return chanceEnum.value.filter((e) => [1, 2].includes(e.status))
  } else if (props.type === 'edit') {
    return chanceEnum.value.filter((e) => {
      if (e.chanceId === defaultChanceId.value && [4, 5].includes(e.status)) {
        e.disabled = true
      }
      return e.chanceId === defaultChanceId.value || [1, 2].includes(e.status)
    })
  } else {
    return chanceEnum.value
  }
})
// 记录编辑前的商机数据
const defaultChanceId = ref('')
watch(
  () => dataForm.chanceId,
  (newVal, oldVal) => {
    if (!defaultChanceId.value && oldVal == null && newVal) {
      defaultChanceId.value = newVal
    }
  }
)

const emit = __emit
watch(
  () => props.value,
  (val) => {
    if (!val) return
    // 如果值相同则不更新
    const isSame = isEqual(toRaw(dataForm), toRaw(val))
    if (isSame) return
    const clone = cloneDeep(val)
    if (clone.chanceId === '0') {
      clone.chanceId = undefined
    }
    Object.assign(dataForm, clone)
  },
  { deep: true, immediate: true }
)
watch(
  dataForm,
  (val) => {
    emit('update:value', val)
  },
  { deep: true }
)
// 回显数据监听客户名称变化
watch(
  () => dataForm.visitRefId,
  (val) => {
    if (val) {
      getChanceEnum(val)
    }
  },
  { immediate: true }
)
watch(
  querySaleChanceRefId,
  (val) => {
    if (val) {
      dataForm.visitRefId = val as string
    }
  },
  { immediate: true }
)
// 监听判断“提醒时间”是否必填
// 当访客提醒选择其他时间时，“提醒时间”字段必填
watch(
  () => dataForm.remindType,
  (val) => {
    setTimeout(() => clearValidate(['remindTime']), 0)
    isOtherTime.value = val === 4
    if (val && val !== 4) dataForm.remindTime = undefined
  },
  { immediate: true }
)
watch(
  () => dataForm.chanceId,
  (val) => {
    setTimeout(() => clearValidate(['chanceId']), 0)
  }
)

const { resetFields, validate, clearValidate, validateInfos } = useForm(dataForm, formRules)
__expose({ resetFields, validate, clearValidate })

return (_ctx: any,_cache: any) => {
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, { scrollToFirstError: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_card, {
        title: props.title,
        span: 6
      }, {
        default: _withCtx(() => [
          _createVNode(_component_dc_form_item, _mergeProps({
            label: _unref(t)('visitor.customerName')
          }, _unref(validateInfos).visitRefId), {
            default: _withCtx(() => [
              _createVNode(ClueAndCustomerSelect, {
                appId: "cos_ofbu",
                value: dataForm.visitRefId,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm.visitRefId) = $event)),
                label: dataForm.customerName,
                "onUpdate:label": _cache[1] || (_cache[1] = ($event: any) => ((dataForm.customerName) = $event)),
                disabled: !props.isEdit || !!props.saleChanceRefId,
                view: props.type === 'view',
                onChange: handleCustomerNameChange
              }, null, 8, ["value", "label", "disabled", "view"])
            ]),
            _: 1
          }, 16, ["label"]),
          (props.type === 'view')
            ? (_openBlock(), _createBlock(_component_dc_form_item, {
                key: 0,
                label: _unref(t)('visitor.cosId')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CosInput, {
                    value: dataForm.visitRefId,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((dataForm.visitRefId) = $event)),
                    view: ""
                  }, null, 8, ["value"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          _createVNode(_component_dc_form_item, _mergeProps({
            label: _unref(t)('visitor.title')
          }, _unref(validateInfos).title), {
            default: _withCtx(() => [
              _createVNode(_component_CosInput, {
                value: dataForm.title,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((dataForm.title) = $event)),
                maxlength: 100,
                disabled: !props.isEdit,
                view: props.type === 'view'
              }, null, 8, ["value", "disabled", "view"])
            ]),
            _: 1
          }, 16, ["label"]),
          _createVNode(_component_dc_form_item, _mergeProps({
            label: _unref(t)('visitor.visitortime')
          }, _unref(validateInfos).startTime), {
            default: _withCtx(() => [
              _createVNode(CosSingleDateTimePicker, {
                isOutputBeijingTime: "",
                startTime: dataForm.startTime,
                "onUpdate:startTime": _cache[4] || (_cache[4] = ($event: any) => ((dataForm.startTime) = $event)),
                endTime: dataForm.endTime,
                "onUpdate:endTime": _cache[5] || (_cache[5] = ($event: any) => ((dataForm.endTime) = $event)),
                isRange: true,
                view: props.type === 'view'
              }, null, 8, ["startTime", "endTime", "view"])
            ]),
            _: 1
          }, 16, ["label"]),
          _createVNode(_component_dc_form_item, _mergeProps({
            label: _unref(t)('visitor.visitorPurpose')
          }, _unref(validateInfos).purpose), {
            default: _withCtx(() => [
              _createVNode(_component_ParamCodesSelect, {
                value: dataForm.purpose,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((dataForm.purpose) = $event)),
                options: paramCodeData.ofbu_follow_purpose,
                disabled: !props.isEdit,
                view: props.type === 'view',
                allowClear: ""
              }, null, 8, ["value", "options", "disabled", "view"])
            ]),
            _: 1
          }, 16, ["label"]),
          _createVNode(_component_dc_form_item, _mergeProps({
            label: _unref(t)('visitor.visitorMode')
          }, _unref(validateInfos).mode), {
            default: _withCtx(() => [
              _createVNode(_component_ParamCodesSelect, {
                value: dataForm.mode,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((dataForm.mode) = $event)),
                options: paramCodeData.ofbu_follow_mode,
                disabled: !props.isEdit,
                view: props.type === 'view',
                allowClear: ""
              }, null, 8, ["value", "options", "disabled", "view"])
            ]),
            _: 1
          }, 16, ["label"]),
          _createVNode(_component_dc_form_item, _mergeProps({
            label: _unref(t)('visitor.relationBussiess')
          }, _unref(validateInfos).chanceId), {
            default: _withCtx(() => [
              (props.type === 'view')
                ? (_openBlock(), _createBlock(BusinessName, {
                    key: 0,
                    appId: "cos_ofbu",
                    value: dataForm.chanceName,
                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((dataForm.chanceName) = $event))
                  }, null, 8, ["value"]))
                : (_openBlock(), _createBlock(_component_CosSelect, {
                    key: 1,
                    value: dataForm.chanceId,
                    "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((dataForm.chanceId) = $event)),
                    disabled: !props.isEdit,
                    view: props.type === 'view',
                    allowClear: "",
                    onChange: handleChanceChange
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chanceEnumComputed.value, (item) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: item.chanceId,
                          value: item.chanceId,
                          disabled: item.disabled
                        }, {
                          default: _withCtx(() => [
                            _createVNode(BusinessName, {
                              appId: "cos_ofbu",
                              label: item.label,
                              "onUpdate:label": ($event: any) => ((item.label) = $event),
                              value: item.saleChanceName,
                              "onUpdate:value": ($event: any) => ((item.saleChanceName) = $event)
                            }, null, 8, ["label", "onUpdate:label", "value", "onUpdate:value"])
                          ]),
                          _: 2
                        }, 1032, ["value", "disabled"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value", "disabled", "view"]))
            ]),
            _: 1
          }, 16, ["label"]),
          _createVNode(_component_dc_form_item, {
            label: _unref(t)('visitor.remindType')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CosSelect, {
                value: dataForm.remindType,
                "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((dataForm.remindType) = $event)),
                options: _unref(remindTypeEnum),
                disabled: !props.isEdit,
                view: props.type === 'view',
                allowClear: ""
              }, null, 8, ["value", "options", "disabled", "view"])
            ]),
            _: 1
          }, 8, ["label"]),
          (isOtherTime.value)
            ? (_openBlock(), _createBlock(_component_dc_form_item, _mergeProps({
                key: 1,
                label: _unref(t)('visitor.remindTime')
              }, _unref(validateInfos).remindTime), {
                default: _withCtx(() => [
                  _createVNode(CosSingleDateTimePicker, {
                    isOutputBeijingTime: "",
                    startTime: dataForm.remindTime,
                    "onUpdate:startTime": _cache[11] || (_cache[11] = ($event: any) => ((dataForm.remindTime) = $event)),
                    isRange: false,
                    view: props.type === 'view'
                  }, null, 8, ["startTime", "view"])
                ]),
                _: 1
              }, 16, ["label"]))
            : _createCommentVNode("", true),
          _createVNode(_component_dc_form_item, {
            label: _unref(t)('follow.collaborator')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_UserSelect, {
                value: dataForm.fbuAssistPersons,
                "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((dataForm.fbuAssistPersons) = $event)),
                mode: "multiple",
                "max-tag-count": !props.isEdit ? 100 : 'responsive',
                disabled: !props.isEdit,
                view: props.type === 'view',
                allowClear: ""
              }, null, 8, ["value", "max-tag-count", "disabled", "view"])
            ]),
            _: 1
          }, 8, ["label"]),
          (!props.isEdit)
            ? (_openBlock(), _createBlock(_component_dc_form_item, {
                key: 2,
                label: _unref(t)('visitor.completeTime')
              }, {
                default: _withCtx(() => [
                  (props.type !== 'view')
                    ? (_openBlock(), _createBlock(_component_a_date_picker, {
                        key: 0,
                        style: {"width":"100%"},
                        value: dataForm.completeTime,
                        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((dataForm.completeTime) = $event)),
                        format: "YYYY/MM/DD HH:mm:ss",
                        "value-format": "YYYY/MM/DD HH:mm:ss",
                        "show-time": "",
                        disabled: "",
                        placeholder: "t('visitor.completeTime')"
                      }, null, 8, ["value"]))
                    : (_openBlock(), _createBlock(_component_CosInput, {
                        key: 1,
                        value: dataForm.completeTime,
                        "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((dataForm.completeTime) = $event)),
                        view: ""
                      }, null, 8, ["value"]))
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (props.type === 'view')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createVNode(_component_dc_form_item, {
                  label: _unref(t)('common.createByName')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: dataForm.createByName,
                      "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((dataForm.createByName) = $event)),
                      view: ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_dc_form_item, {
                  label: _unref(t)('common.createTime')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: dataForm.createTime,
                      "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((dataForm.createTime) = $event)),
                      view: ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ], 64))
            : _createCommentVNode("", true),
          _createVNode(_component_a_col, { span: 24 }),
          _createVNode(_component_dc_form_item, {
            label: _unref(t)('common.remark'),
            span: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CosTextarea, {
                value: dataForm.remark,
                "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((dataForm.remark) = $event)),
                maxlength: 2000,
                disabled: !props.isEdit,
                view: props.type === 'view'
              }, null, 8, ["value", "disabled", "view"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    _: 1
  }))
}
}

})